/* eslint-disable */

import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { FormControl } from "react-bootstrap";
import * as Constants from '../constants';
import { Modal } from "react-bootstrap";

class ReactiveResponsesForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    handlePrioritySubmit: PropTypes.func.isRequired,
    settings: PropTypes.array.isRequired
  };

  constructor(props) {
    super(props);
    // IMPORTANT: This is where we have to edit reactive_response types and their previews
    // Also make sure to change LM app/models/reactive_responses/reactions/*
    let settingDescs =
      [
        {
          reaction: 'favorite_property',
          desc: 'Lead favorites a Property',
          textPreviewBody: "Hi, [FIRST_NAME]! Thanks for favoriting the property at [PROPERTY ADDRESS]. Would you be interested in checking it out?",
          emailPreviewSubject: "Ready to see some properties?",
          emailPreviewBody: "Hi [FIRST_NAME],\n\nYou've favorited a property on my home search site. Exciting! Are you interested in seeing it or any others? Just shoot me an email with any questions. \n\n[AGENT_EMAIL_SIGNATURE]"
        },
        {
          reaction: 'visited_website',
          desc: 'Lead visits website 3 times in 7 days',
          textPreviewBody: "Hi, [FIRST_NAME]! Checking in on your home search. Have you seen any homes that stand out?",
          emailPreviewSubject: "What are your home search must-haves?",
          emailPreviewBody: "Hi [FIRST_NAME],\n\nYou've been researching properties on my home search site. What are the most important must-haves you're looking for?\n\n[AGENT_EMAIL_SIGNATURE]"
        },
        {
          reaction: 'unique_property_viewed',
          desc: 'Lead views 10 properties within 7 days',
          textPreviewBody: "Hi, [FIRST_NAME]! Checking in on your home search. Have you seen any listings that stand out?",
          emailPreviewSubject: "Ready to see some properties?",
          emailPreviewBody: "Hi [FIRST_NAME],\n\n You've been showing interest in a few properties on my home search site. Would you like me to make some appointments to see any?  \n\n[AGENT_EMAIL_SIGNATURE]"
        },
        {
          reaction: 'revisit_website',
          desc: 'Lead revisits website after 14 days of inactivity',
          textPreviewBody: "Hi [FIRST_NAME] - Are you still thinking of buying or just browsing?",
          emailPreviewSubject: "How can I better assist you?",
          emailPreviewBody: "Hi [FIRST_NAME],\n\nJust curious - are the listings and information I've provided a good fit for your situation? If not, let me know. I want to help your home search in the best way possible.\n\n[AGENT_EMAIL_SIGNATURE]" },
        {
          reaction: 'lead_edited_phone',
          desc: 'Lead updates their Phone Number while visiting the website',
          textPreviewBody:"Hey, [FIRST_NAME]! Thanks for updating your contact info - what's your timeframe looking like or are you still just browsing?",
          emailPreviewSubject: "Thanks for updating your info!",
          emailPreviewBody: "Hey [FIRST_NAME],\n\nThanks for updating your contact info on my website! What's your timeframe to make a move? Do you need something now or are you a ways out? Let me know. \n\n[AGENT_EMAIL_SIGNATURE]"
        },
        {
          reaction: 'home_valuation',
          desc: 'Lead views home valuation 3 times in 30 days',
          textPreviewBody: "Hey, [FIRST_NAME] - just wanted to thank you for your home valuation inquiry. What did you think of the estimate?",
          emailPreviewSubject: "What do you think of your home estimate?",
          emailPreviewBody: "Hi [FIRST_NAME],\n\nYou've been viewing home valuation requests. What’d you think about the estimate you received? Let me know.\n\n[AGENT_EMAIL_SIGNATURE]"
        },
        {
          reaction: 'property_viewed',
          desc: 'Lead views the same property 3 times in 5 days',
          textPreviewBody: "Hello, [FIRST_NAME]! Thank you for your interest in [PROPERTY_ADDRESS] – when would you like to go see it?",
          emailPreviewSubject: "Ready to see some properties?",
          emailPreviewBody: "Hi [FIRSTNAME],\n\n You've been showing interest in a few properties on my home search site. Are there any you'd like to go see? I have time available this week. \n\n[AGENT_EMAIL_SIGNATURE]"
        },
        {
          reaction: 'market_report_viewed',
          desc: 'Lead views market report 3 times in 30 days',
          textPreviewBody: "Hey, [FIRST_NAME] - just wanted to thank you for your market report inquiry. What did you think of the results?",
          emailPreviewSubject: "What do you think of your market report?",
          emailPreviewBody: "Hi [FIRST_NAME],\n\nYou've been viewing market reports. What’d you think about the results? Let me know.\n\n[AGENT_EMAIL_SIGNATURE]"
        }
      ];
    this.state = {
      showModal: false,
      previewType: null,
      previewTitle: null,
      previewSubject: "",
      previewBody: "",
      settings: this.mergeBySystemValue(settingDescs, this.props.settings),
      prioritize: this.props.settings[0]?.prioritize || false
    };
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    this.setState({ showModal: true });
  }

  open(e) {
    this.setState({ previewType: e.target.dataset.preview_type, previewTitle: e.target.dataset.preview_title, previewBody: e.target.dataset.preview_body, previewSubject: e.target.dataset.preview_subject });
    this.openModal();
  }

  mergeBySystemValue(arr1, arr2) {
    const map = new Map();
    arr1.forEach(item => map.set(item.reaction, item));
    arr2.forEach(item => map.set(item.reaction, {...map.get(item.reaction), ...item}));
    return Array.from(map.values());
  }

  handleChange(e) {
    let changedArr = [{reaction: e.target.id, enabled: e.target.checked}];
    let tempSettings = this.mergeBySystemValue(this.state.settings, changedArr);
    this.setState({ settings: tempSettings });
    this.props.handleSubmit({ settings: tempSettings });
  }

  handlePriorityChange(e) {
    let newPrioritize = e.target.value;
    this.setState({ prioritize: newPrioritize });
    this.props.handlePrioritySubmit({ prioritize: newPrioritize });
  }

  renderSettingRows() {
    let rows = this.state.settings.map(i => {
      return this.renderSettingRow(i);
    });
    return rows;
  }

  renderSettingRow(setting) {
    let featureFlags = JSON.parse(localStorage.getItem('featureFlags'));
    return (
      <div className="row m-t-5 borderbottom" key={setting.reaction}>
        <div className="col-sm-1 toggle_checkbox">
          <div className="checkbox">
            <input
              type="checkbox"
              id={setting.reaction}
              ref={setting.reaction}
              onChange={this.handleChange.bind(this)}
              checked={setting.enabled}
            />
            <label></label>
          </div>
        </div>
        <div className="col-sm-7 m-t-10">
          <span>{setting.desc}</span>
        </div>
        <div className="col-sm-1 m-t-10">
          <Link
            className="m-r-20"
            data-preview_type="Text"
            data-preview_title={setting.desc}
            data-preview_subject=""
            data-preview_body={setting.textPreviewBody}
            onClick={this.open.bind(this)}
          >
            Text
          </Link>
        </div>
        <div className="col-sm-3 m-t-10">
          {" "}
          { featureFlags['reactive_response_email_fallback'] &&
            <Link
              className=""
              data-preview_type="Email"
              data-preview_title={setting.desc}
              data-preview_subject={setting.emailPreviewSubject}
              data-preview_body={setting.emailPreviewBody}
              onClick={this.open.bind(this)}
            >
              Email
            </Link>
          }
        </div>
      </div>
    );
  }

  render() {
    let featureFlags = JSON.parse(localStorage.getItem('featureFlags'));
    return (
      <div>
        { featureFlags['reactive_response_prioritize'] &&
          <div>
            <h3>
              How should your Reactive Responses be sent?
            </h3>
            <p>
              Select which channel you want to use to send Reactive Response messages:
            </p>
            <p>
              <input
                className="m-5"
                type="radio"
                id={'prioritize-sms'}
                ref={'prioritize-sms'}
                value={'sms'}
                onChange={this.handlePriorityChange.bind(this)}
                checked={this.state.prioritize == 'sms'}
              />
              <label className="m-l-15 m-r-40" for="prioritize-sms">Text Message</label>
              <input
                type="radio"
                id={'prioritize-email'}
                ref={'prioritize-email'}
                value={'email'}
                onChange={this.handlePriorityChange.bind(this)}
                checked={this.state.prioritize == 'email'}
              />
              <label className="m-15" for="prioritize-email">Email</label>
            </p>
            { this.state.prioritize == 'sms' &&
              <p>
                If a text fails to send because a phone number is bad or the message is not delivered, an email will be sent instead.
              </p>
            }
            { this.state.prioritize == 'email' &&
              <p>
                Only an email will be sent, no text messages.
              </p>
            }
          </div>
        }
        <div className="row borderbottom m-t-20">
          <div className="col-sm-8">
            <label>Toggle Off/On</label>
          </div>
          <div className="col-sm-4">
            <label>Preview Message</label>
          </div>
        </div>
        {this.renderSettingRows()}
        <Modal
          show={this.state.showModal}
          onHide={this.closeModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={true}
          dialogClassName='narrow-modal-dialog'
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">{this.state.previewType} Preview - {this.state.previewTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            { this.state.previewType == "Email" &&
              <div>
                <strong>Subject:</strong>
                {this.state.previewSubject.split('\n').map(chunk => <p>{chunk}</p>)}
              </div>
            }
            <strong>Body:</strong>
            {this.state.previewBody.split('\n').map(chunk => <p>{chunk}</p>)}
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default ReactiveResponsesForm;
